import React, {  useRef } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from "@ag-grid-community/react";

const TsGrid = (props, ref) => {

  const gridRef = useRef(null);



  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    cellStyle: { 
      textAlign: 'left', 
      whiteSpace: 'nowrap',
      overflow: 'hidden', 
      textOverflow: 'ellipsis',
    },
    flex: 1, 
  };

  return (
    <div className="ag-theme-alpine" style={{ height: '90%',width:'100%' }}> 
      <AgGridReact
        ref={gridRef} 
        defaultColDef={defaultColDef}
        pagination={false}
        enableColResize={true}
        {...props}
      />
    </div>
  );
};

export default TsGrid;